import React, { Component } from 'react';
import localize from '../localize';
import getIspData from '../../utils/get_isp_data'
import { getOffset, applyOffset } from '../../utils/time'
import Select from '../Select';
import Timeseries from '../Timeseries';
import { IspDataTable } from '../ScoreCards'
import ScoreNumber from '../ScoreNumber'
import './Comparison.css';

const getTimeseriesData = (timeseriesData, isp, location) => {
  if (!timeseriesData || !timeseriesData[location.id] || !timeseriesData[location.id][isp.name] || timeseriesData[location.id][isp.name].loading || timeseriesData[location.id][isp.name].error) {
    return false
  } else {
    return timeseriesData[location.id][isp.name]
  }
}

//TODO make this less hard-coded.
class Comparison extends Component {
  static defaultProps = {
    columnCount: 2
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedIsps: this.getIsps()
    };
  }

  getIsps() {
    const props = this.props
    let topIsps = this.props.isps.slice();

    topIsps.sort((a, b) => {
      return getIspData(a.stats).stats_ethernet.connection_score < getIspData(b.stats).stats_ethernet.connection_score;
    });

    if(props.playerIsp && !props.playerIsp.is_private && !props.playerIsp.not_enough_data) {
      topIsps.unshift(props.playerIsp);
    }

    return topIsps.slice(0, this.props.columnCount)
  }

  componentDidMount() {
    this.setState({
      selectedIsps: this.getIsps()
    })
  }

  componentDidUpdate(lastProps) {
    if ((this.props.location || {}).id !== (lastProps.location || {}).id || (this.props.playerIsp && this.props.playerIsp.id) !== (lastProps.playerIsp && lastProps.playerIsp.id)) {
      this.setState({
        selectedIsps: this.getIsps()
      })
    }
  }

  onIspChange({ value }, index) {
    let selectedIsps = this.state.selectedIsps.slice();
    selectedIsps[index] = this.props.isps.find(isp => isp.id === value);

    this.setState({
      selectedIsps
    });
  }

  options() {
    let options = this.props.isps.map(isp => ({ label: `${isp.name} (${getIspData(isp.stats).stats_ethernet.connection_score})`, value: isp.id }));

    options.sort((a, b) => {
      return a.label > b.label ? 1 : -1;
    });

    return options;
  }

  enoughData(timeseries, location, isp) {
    const tsData = getTimeseriesData(timeseries.timeseriesData, isp, location)
    if (!tsData) {
      return false
    }

    const dataset = tsData.data
      .slice()
      .map(a => ({ ...a, window_start: applyOffset(applyOffset(a.window_start, getOffset(tsData.offset)), -28800) }))
      .sort((a, b) => a.window_start - b.window_start)

    var last = -1
    var consec = 0
    var maxConsec = 0

    dataset.forEach(d => {
      if ((last === -1 || parseInt(d.window_start, 10) === last + 3600) && d.stats_ethernet) {
        consec += 1
      } else {
        maxConsec = Math.max(maxConsec, consec)
        consec = 1
      }
      last = parseInt(d.window_start, 10)
    })

    return Math.max(maxConsec, consec) >= 8
  }

  render() {
    const { i18n, location, timeseries, fetchTimeseries, shard } = this.props;

    if(this.props.isps.length > 1) {
      const options = this.options();

      return <div className="comparison">
              <div className="isp-selector">
                <div className="isp-option">
                  <Select name="isp1" clearable={false} options={options} value={this.state.selectedIsps[0].id} onChange={selected => this.onIspChange(selected, 0)} />
                  <div className="isp-label isp-label-a">
                    {
                      this.enoughData(timeseries, location, this.state.selectedIsps[0])?
                      <span><strong>&mdash;&mdash;</strong>&nbsp;&nbsp;&nbsp;{this.state.selectedIsps[0].name}</span> :
                      <span className="isp-label-not-enough"><q-icon name="close"/> { i18n.t('not_enough') }</span>
                    }
                  </div>
                </div>
                <div className="isp-option">
                  <Select name="isp2" clearable={false} options={options} value={this.state.selectedIsps[1].id} onChange={selected => this.onIspChange(selected, 1)} />
                  <div className="isp-label isp-label-b">
                    {
                      this.enoughData(timeseries, location, this.state.selectedIsps[1])?
                      <span><strong>&mdash;&mdash;</strong>&nbsp;&nbsp;&nbsp;{this.state.selectedIsps[1].name}</span> :
                      <span className="isp-label-not-enough"><q-icon name="close"/> { i18n.t('not_enough') }</span>
                    }
                  </div>
                </div>
              </div>
              <Timeseries dataA={this.state.selectedIsps[0]} dataB={this.state.selectedIsps[1]} compareKey="connection_score" location={location} timeseries={timeseries} fetchTimeseries={fetchTimeseries} shard={shard} />
              <div className="side-by-side">
                <div className="side-by-side-section">
                  <div className="side-by-side-header"><strong>{this.state.selectedIsps[0].name}</strong></div>
                  <div className="side-by-side-content">
                    <ScoreNumber value={getIspData(this.state.selectedIsps[0].stats).stats_ethernet.connection_score} size="md" />
                    <div className="side-by-side-table">
                      <IspDataTable stats={getIspData(this.state.selectedIsps[0].stats).stats_ethernet} />
                    </div>
                  </div>
                </div>
                <div className="vs">
                  <div className="vs-line">
                    <div className="vs-circle">{i18n.t('vs')}</div>
                  </div>
                </div>
                <div className="side-by-side-section">
                  <div className="side-by-side-header"><strong>{this.state.selectedIsps[1].name}</strong></div>
                  <div className="side-by-side-content">
                    <ScoreNumber value={getIspData(this.state.selectedIsps[1].stats).stats_ethernet.connection_score} size="md" />
                    <div className="side-by-side-table">
                      <IspDataTable stats={getIspData(this.state.selectedIsps[1].stats).stats_ethernet} />
                    </div>
                  </div>
                </div>
              </div>
            </div>;
    } else {
      return null;
    }
  }
};

export {
  Comparison
};

export default localize('pages.scores.compare')(Comparison);



// WEBPACK FOOTER //
// ./src/components/Comparison/index.js